/*
Fork addition (Stage H): shared clipboard helper, extracted from the
Stage D Copy Blueprint button so the bottom-right action dock copies
text the same way — Clipboard API first, legacy textarea/execCommand
fallback when the API is unavailable (permissions / insecure context).
Returns true when the text actually landed on the clipboard.
*/
export async function copyTextToClipboard(text: string): Promise<boolean> {
    try {
        await navigator.clipboard.writeText(text);
        return true;
    } catch(err) {
        //fall through to the legacy path
    }
    try {
        const textArea = document.createElement('textarea');
        textArea.value = text;
        textArea.style.position = 'fixed';
        textArea.style.opacity = '0';
        document.body.appendChild(textArea);
        textArea.select();
        const ok = document.execCommand('copy');
        document.body.removeChild(textArea);
        return ok;
    } catch(err) {
        return false;
    }
}
